export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的商店"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未找到商店"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建小部件代码"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建支付链接"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除商店"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您确定要删除商店"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册商店"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代码"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名称"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付模式"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接受"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["URL"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索..."])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新商店"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册新商店"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["所有商店"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["排序"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建新商店"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["草稿商店"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更新日期"])}
}